import React, { useState } from 'react'
import { CCard, CCardBody, CForm, CFormInput, CFormTextarea, CFormLabel, CButton, CRow, CCol, CContainer } from '@coreui/react'
import { CAvatar } from '@coreui/react'
import { MedicalInformation } from '@mui/icons-material'
import avatar8 from './../../assets/images/avatars/logo1.jpg'

import { Link } from 'react-router-dom'
import { Clipboard, Receipt } from 'lucide-react'
import { Button } from 'react-bootstrap'
const Contactus = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    website: '',
    message: '',
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // Reset form
    setFormData({
      name: '',
      email: '',
      website: '',
      message: '',
    })
  }

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
        <div className="container">
          <div className="d-flex align-items-center">
            <CAvatar src={avatar8} style={{ width: '3rem', borderRadius: '0' }} />
            <span className=" " style={{ color: '#4FC3F7', fontSize: '20px', padding: '0px 10px' }}>
              Provio Solutions
            </span>
          </div>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link" href="#services">
                  Services
                </a>
              </li>
              {/* <li className="nav-item">
                                    <a className="nav-link" href="#about">Career</a>
                                </li> */}
              <li className="nav-item pl-4">
                <Link to="/login">
                  <Button>Login</Button>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <CContainer className="py-5">
        <CCard className=" border-0">
          <CCardBody className="p-5">
            <div className="mb-4">
              <h1 className="display-4 fw-bold text-dark mb-2">Contact Us</h1>
            </div>

            <CForm onSubmit={handleSubmit}>
              {/* Name and Email Row */}
              <CRow className="mb-4">
                <CCol md={6} className="mb-3 mb-md-0">
                  <CFormLabel htmlFor="name" className="text-muted fw-medium mb-2">
                    Tell us your name <span className="text-danger">*</span>
                  </CFormLabel>
                  <CFormInput type="text" id="name" name="name" placeholder="Enter your name" value={formData.name} onChange={handleInputChange} required className="form-control-md bg-light border-0" style={{ transition: 'all 0.2s ease' }} />
                </CCol>

                <CCol md={6}>
                  <CFormLabel htmlFor="email" className="text-muted fw-medium mb-2">
                    Enter your email <span className="text-danger">*</span>
                  </CFormLabel>
                  <CFormInput type="email" id="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleInputChange} required className="form-control-md bg-light border-0" style={{ transition: 'all 0.2s ease' }} />
                </CCol>
              </CRow>

              {/* Website Field */}
              <div className="mb-4">
                <CFormLabel htmlFor="website" className="text-muted fw-medium mb-2">
                  Your Website
                </CFormLabel>
                <CFormInput type="url" id="website" name="website" placeholder="http://" value={formData.website} onChange={handleInputChange} className="form-control-md bg-light border-0" style={{ transition: 'all 0.2s ease' }} />
              </div>

              {/* Message Field */}
              <div className="mb-4">
                <CFormLabel htmlFor="message" className="text-muted fw-medium mb-2">
                  Message
                </CFormLabel>
                <CFormTextarea
                  id="message"
                  name="message"
                  placeholder="Your message here..."
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={6}
                  className="form-control-md bg-light border-0"
                  style={{
                    resize: 'none',
                    transition: 'all 0.2s ease',
                  }}
                />
              </div>

              {/* Submit Button */}
              <div className="text-center pt-3">
                <CButton
                  type="submit"
                  size="lg"
                  className="px-4 py-3 fw-semibold text-uppercase"
                  style={{
                    background: 'linear-gradient(135deg, #007bff 0%, #28a745 100%)',
                    border: 'none',
                    borderRadius: '0.375rem',
                    boxShadow: '0 10px 25px rgba(0,123,255,0.3)',
                    transition: 'all 0.3s ease',
                    transform: 'scale(1)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)'
                    e.currentTarget.style.background = 'linear-gradient(135deg, #0056b3 0%, #1e7e34 100%)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)'
                    e.currentTarget.style.background = 'linear-gradient(135deg, #007bff 0%, #28a745 100%)'
                  }}
                >
                  SUBMIT
                </CButton>
              </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CContainer>
    </div>
  )
}

export default Contactus
